'use client';

import type { ComponentProps } from 'react';
import { FaTimes } from 'react-icons/fa';

import styles from './circle-close-button.component.module.scss';

type Props = ComponentProps<'button'> & {
  autoFocus?: boolean;
};

export const CircleCloseButton = ({
  autoFocus = true,
  className,
  ...props
}: Props) => (
  <button
    autoFocus={autoFocus}
    className={[className, styles.circleCloseButton].filter(Boolean).join(' ')}
    {...props}
  >
    <FaTimes aria-hidden />
  </button>
);
